import axios from 'axios'
import moment from 'moment'

axios.defaults.withCredentials = true;

// Browser requests stay on the current deployment. Server-side rendering uses
// that deployment's configured address and forwards the existing session cookie.
const BASE_URL = typeof window === 'undefined'
  ? (process.env.APP_BASE_URL || 'http://localhost:3000').replace(/\/$/, '')
  : '';

export { axios, moment, BASE_URL }
